import { useQuery } from '@tanstack/react-query'
import { Link, createFileRoute } from '@tanstack/react-router'
import { CircleCheckBig } from 'lucide-react'
import { remindersQuery } from '@/api/queries'
import { Card } from '@/components/ui/card'
import { EmptyState } from '@/components/ui/empty-state'
import { FollowUpActions } from '@/features/notifications/follow-up-actions'

const FOLLOW_UP: Record<number, { title: string; actions: string[] }> = {
  1: { title: 'Have you sent the design to the client?', actions: ['sent', 'not_yet'] },
  2: { title: 'Any feedback from the client?', actions: ['quoted', 'still_waiting', 'lost'] },
}
const LATER = { title: 'Update the outcome', actions: ['won', 'lost', 'still_pending', 'on_hold'] }

/** Where a follow-up push notification opens: the question with one-tap answers. */
export const Route = createFileRoute('/_app/reminders/$reminderId')({ component: ReminderPage })

function ReminderPage() {
  const { reminderId } = Route.useParams()
  const { data, isLoading } = useQuery(remindersQuery)
  const r = data?.find((x) => x.id === reminderId)
  if (isLoading) return <p className="p-6 text-fg-muted">Loading...</p>
  if (!r) {
    return (
      <EmptyState icon={CircleCheckBig} title="Already answered">
        <Link to="/" className="font-semibold text-brand-text underline">
          Go home
        </Link>
      </EmptyState>
    )
  }
  const q = r.kind === 'follow_up' ? (FOLLOW_UP[r.step ?? 3] ?? LATER) : null
  return (
    <div className="mx-auto flex max-w-xl flex-col gap-6">
      <h1 className="text-3xl uppercase">{q?.title ?? 'Reminder'}</h1>
      <Card className="flex flex-col gap-4">
        <p className="text-lg font-semibold">{r.project_name}</p>
        {r.message && <p>{r.message}</p>}
        {r.from_name && <p className="text-fg-muted">From {r.from_name}</p>}
        {q && <FollowUpActions reminderId={r.id} reluxId={r.relux_id} actions={q.actions} />}
        {r.relux_id && (
          <Link
            to="/reluxes/$reluxId"
            params={{ reluxId: r.relux_id }}
            className="font-semibold text-brand-text underline underline-offset-4"
          >
            Open the design
          </Link>
        )}
      </Card>
    </div>
  )
}
